import { render, staticRenderFns } from "./DDwalletAgreement.vue?vue&type=template&id=dcd6e2e0&scoped=true"
import script from "./DDwalletAgreement.vue?vue&type=script&lang=js"
export * from "./DDwalletAgreement.vue?vue&type=script&lang=js"
import style0 from "./DDwalletAgreement.vue?vue&type=style&index=0&id=dcd6e2e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd6e2e0",
  null
  
)

export default component.exports